<div class="header-container">
    <div class="header">
        <div class="logo" (click)="navigateToHome()">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="108.689" height="25.237" viewBox="0 0 108.689 25.237">
                <defs>
                    <clipPath id="clip-path">
                        <rect id="Rectangle_3506" data-name="Rectangle 3506" width="108.689" height="25.237" fill="#fff"/>
                    </clipPath>
                </defs>
                <g id="Group_10235" data-name="Group 10235" transform="translate(0 0)">
                    <path id="Path_4422" data-name="Path 4422" d="M41.243.227V24.773H58.325v-4.9H48V15.267h6.461V10.16H48V5.129H58.325V.227Z" transform="translate(23.701 0.131)" fill="#fff"/>
                    <g id="Group_10234" data-name="Group 10234" transform="translate(0 0)">
                        <g id="Group_10233" data-name="Group 10233" clip-path="url(#clip-path)">
                            <path id="Path_4423" data-name="Path 4423" d="M42.252,15.972A8.025,8.025,0,0,0,39.832.3H27.027V24.865h6.752V16.359h1.4L40.67,24.8h8.07l-6.425-8.738ZM40.235,9.484a2.981,2.981,0,0,1-2.872,2.2h-3.6V5.7h3.6a3.008,3.008,0,0,1,3,2.995,2.739,2.739,0,0,1-.124.792"
                                  transform="translate(15.531 0.17)" fill="#fff"/>
                            <path id="Path_4424" data-name="Path 4424" d="M19.553,6.041A3.119,3.119,0,1,0,22.673,9.16a3.114,3.114,0,0,0-3.119-3.119" transform="translate(9.444 3.472)" fill="#fff"/>
                            <path id="Path_4425" data-name="Path 4425" d="M28.992,0A12.623,12.623,0,0,0,18,18.827H6.751V.357H0V24.911H18.469V19.587A12.609,12.609,0,1,0,28.992,0m0,19.587a6.969,6.969,0,1,1,6.969-6.954,6.968,6.968,0,0,1-6.969,6.954" transform="translate(0 0)" fill="#fff"/>
                            <path id="Path_4426" data-name="Path 4426" d="M69.438,12.464,78.462.227H70.608L65.52,7.3,60.413.227H52.578l9.005,12.237L52.5,24.774h7.854l5.162-7.168,5.143,7.168h7.854Z" transform="translate(30.171 0.131)" fill="#fff"/>
                        </g>
                    </g>
                </g>
            </svg>

        </div>
        <div class="header-icons">
            <ng-container *ngIf="userAuthentcataed">
     <span class="header-logo">
         <a href="https://www.lorex.com/" target="_blank">
       <svg xmlns="http://www.w3.org/2000/svg" width="34.027" height="31.1" viewBox="0 0 34.027 31.1">
         <g id="Group_10236" data-name="Group 10236" transform="translate(-4177.669 2862.331)">
           <path id="Path_4429" data-name="Path 4429" d="M7.011,5.484l25.816.367-2,7.827a3.684,3.684,0,0,1-3.181,2.77L11.377,18.143l-.019-.058L7.011,5.484,6.08,2.791A2.638,2.638,0,0,0,3.588,1H1" transform="translate(4177.769 -2862.231)" fill="none" stroke="#fcfcfc" stroke-linecap="round"
                 stroke-linejoin="round" stroke-width="2.2"/>
           <path id="Path_4430" data-name="Path 4430" d="M16.691,27.52a2.923,2.923,0,0,0,1.92,5.135H33.783" transform="translate(4172.207 -2871.883)" fill="none" stroke="#fcfcfc" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2"/>
           <path id="Path_4431" data-name="Path 4431" d="M19.471,42.246a2.764,2.764,0,1,1-2.764-2.764,2.764,2.764,0,0,1,2.764,2.764" transform="translate(4173.058 -2876.242)" fill="#fcfcfc"/>
           <path id="Path_4432" data-name="Path 4432" d="M42.465,42.246A2.764,2.764,0,1,1,39.7,39.482a2.764,2.764,0,0,1,2.764,2.764" transform="translate(4164.645 -2876.242)" fill="#fcfcfc"/>
         </g>
       </svg>
         </a>
     </span>

                <span class="user-icon-span"
                      (click)="openDropdown()">
       <svg xmlns="http://www.w3.org/2000/svg" width="35.119" height="35.119" viewBox="0 0 35.119 35.119">
         <g id="Group_10237" data-name="Group 10237" transform="translate(-1756.9 -31.9)">
           <path id="Union_1" data-name="Union 1"
                 d="M3.2,25.547C1.127,25.262-.3,22.257.053,20.165L.1,19.9a9.256,9.256,0,0,1,9.764-7.837A9.34,9.34,0,0,1,18.4,19.9l.046.266c.35,2.092-1.074,5.1-3.142,5.382a44.3,44.3,0,0,1-6.055.416A44.27,44.27,0,0,1,3.2,25.547ZM3.7,4.655A5.6,5.6,0,0,1,9.249-1,5.6,5.6,0,0,1,14.8,4.655a5.6,5.6,0,0,1-5.548,5.654A5.6,5.6,0,0,1,3.7,4.655Z"
                 transform="translate(1765.21 39.424)" fill="#fcfcfc" stroke="rgba(0,0,0,0)" stroke-miterlimit="10" stroke-width="1"/>
           <circle id="Ellipse_849" data-name="Ellipse 849" cx="16.459" cy="16.459" r="16.459" transform="translate(1758 33)" fill="none" stroke="#fcfcfc" stroke-width="2.2"/>
         </g>
       </svg>
     </span>

                <div class="dropdown">
                    <div class="dropdown-header">
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton" *ngIf="menuOpen">
                            <li><a class="dropdown-item" (click)="onClickMyAccount()" i18n="@@myAccount">My Account</a></li>
                            <li><a class="dropdown-item" (click)="onClickMyDevices()" i18n="@@myDevices">My Devices</a></li>
                            <li><a class="dropdown-item" (click)="onClickMySubscriptions()" i18n="@@mySubscriptions">My Subscriptions</a></li>
                            <li><a class="dropdown-item" (click)="onClickManageSubscription()" i18n="@@manageSubscriptions">Manage Subscriptions</a></li>
                            <li><a class="dropdown-item" (click)="onClickSignUp()" i18n="@@logout">Logout</a></li>
                        </ul>
                    </div>
                </div>

            </ng-container>
            <div class="select-language">
                <select class="form-select" aria-label="Default select example" (change)="selectLanguage($event)" [(ngModel)]="selectedLanguage">
                    <option *ngFor="let locale of localesList" value="{{locale?.code}}"> {{ locale?.label }}</option>
                </select>
            </div>
        </div>

    </div>

    <!--
    Header ribbon
    <div style="color: white; background-color: #101828; text-align: center; padding: 10px 0; width: 100%"><span style="color:  rgb(49, 248, 253); font-weight: bolder">Holiday Deal:</span> Get 50% off the first year of the annual plan.</div>
    -->
</div>